import React from 'react'
import styled from 'styled-components'
import ImageCarousel from './ImageCarousel'

import { ReactComponent as X } from 'icons/x-icon.svg'

export default ({ showModal, toggleModal, name, description, link, images }) =>
  showModal ? (
    <Background>
      <Content>
        <ImgDiv>
          <ImageCarousel images={images} />
          <Close onClick={toggleModal} />
        </ImgDiv>
        <Details>
          <Name>
            {name}

            {link && (
              <SiteLink href={link} target="_blank">
                Learn More
              </SiteLink>
            )}
          </Name>
          <Text>{description}</Text>
        </Details>
      </Content>
    </Background>
  ) : null

const Background = styled.div`
  overflow: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  animation: openModal 0.5s;

  @keyframes openModal {
    from {
      opacity: 0;
      transform: scale(1.025);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`
const Close = styled(X)`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 20px;
  top: 20px;
  cursor: pointer;

  path {
    stroke: white;
    stroke-width: 2px;
  }
`
const Content = styled.div`
  position: relative;
  margin: 10vw auto;
  width: 80%;
  max-width: 800px;
  max-height: calc(100% - 120px);
  background-color: white;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.45);

  @media (max-width: ${props => props.theme.tablet}px) {
    width: 90%;
    margin: 5vw auto;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    width: 100%;
    margin: 0;
  }
`
const ImgDiv = styled.div`
  position: relative;
`
const Details = styled.div`
  padding: 40px 60px;
  width: 100%;
  background-color: white;
  position: relative;

  @media (max-width: ${props => props.theme.tablet}px) {
    padding: 20px;
    margin-bottom: 20px;
  }
`
const Name = styled.h1`
  width: 100%;
  padding: 0 0 15px;
  border-bottom: 1px solid #d5dceb;
  font-size: 20px;
  line-height: 26px;
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.semiBold};
  color: ${props => props.theme.fontColor};
  margin: 0 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Text = styled.div`
  font-size: 14pt;
  line-height: 21pt;
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.light};
  color: ${props => props.theme.fontColor};

  @media (max-width: ${props => props.theme.tablet}px) {
    font-size: 12pt;
    line-height: 18pt;
  }
`
const SiteLink = styled.a`
  padding: 10px 20px;
  border-radius: 25px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  line-height: 0;
  text-align: center;
  font-weight: ${props => props.theme.semiBold};
  font-family: ${props => props.theme.primaryFont};
  color: white;
  transition-duration: 0.3s;
  cursor: ${props => props.cursor};
  background-color: ${props => props.theme.mainColor};
  border: none;

  &:hover {
    background-color: #0a6dc3;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    padding: 23px 20px;
    border-radius: 25px;
    font-size: 20px;
  }
`
